import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { ButtonLink } from '../General/Button';
import { __ } from 'react-i18n';
import { SpecsList } from './SpecsList';

interface Props {
  attribs: any[];
  onClickAll?: any;
  isQuickBuy?: boolean;
}

function SpecTable({ attribs, onClickAll, isQuickBuy }: Props) {
  if (isQuickBuy) {
    return <SpecsList attribs={attribs} />;
  }

  return (
    <Wrapper isQuickBuy={isQuickBuy}>
      <Title>{__('Technická špecifikácia')}</Title>
      <SpecsList attribs={attribs} />
      {!!onClickAll && (
        <ShowAllButton onClick={onClickAll}>
          {__('Zobraziť všetko')}
        </ShowAllButton>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)<{ isQuickBuy?: boolean }>`
  border: ${({ theme }) => theme.borders.weak};
  border-radius: ${rem(4)};
  max-width: ${rem(448)};
  width: 100%;
  padding: ${rem(24)};
  margin-left: ${rem(24)};

  ${({ theme, isQuickBuy }) => theme.mediab.l1300`
    display: ${isQuickBuy ? 'flex' : 'none'} ;
  `}
`;

const Title = styled.h3`
  font-size: ${rem(20)};
  line-height: ${rem(22)};
  font-family: ${({ theme }) => theme.font.primary};
  margin: 0;
  margin-bottom: ${rem(28)};
  font-weight: 400;
`;

const ShowAllButton = styled.span`
  cursor: pointer;
  font-size: ${rem(14)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
  line-height: ${rem(22)};
  margin-top: ${rem(28)};
`;

export { SpecTable };
